import React, { memo } from 'react';
import MultiSelectFilter, {
  SHOW_ALL_KEY
} from '@components/Approval/MultiSelectFilter/MultiSelectFilter';
import { CheckIcon } from '@icons';

const statusItems = [
  {
    key: SHOW_ALL_KEY,
    name: 'Show all',
    label: (
      <>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#161819' }} />
          <span>Show all</span>
        </div>
        <CheckIcon />
      </>
    ),
    className: 'status-menu-item'
  },
  {
    key: 'in_progress',
    name: 'In Review',
    label: (
      <>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#FAECCC' }} />
          <span>In Review</span>
        </div>
        <CheckIcon />
      </>
    ),
    className: 'status-menu-item'
  },
  {
    key: 'approved',
    name: 'Approved',
    label: (
      <>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#92D1BA' }} />
          <span>Approved</span>
        </div>
        <CheckIcon />
      </>
    ),
    className: 'status-menu-item'
  },
  {
    key: 'changes_required',
    name: 'Changes Required',
    label: (
      <>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#F7CAB0' }} />
          <span>Changes Required</span>
        </div>
        <CheckIcon />
      </>
    ),
    className: 'status-menu-item'
  },
  {
    key: 'approved_with_feedback',
    name: 'Approved with Feedback',
    label: (
      <>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#BFC5F4' }} />
          <span>Approved with Feedback</span>
        </div>
        <CheckIcon />
      </>
    ),
    className: 'status-menu-item'
  }
];

type StatusesFilterProps = {
  onChange: (value: string[]) => void;
  selectedStatuses: string[];
};

export default memo(function StatusesFilter({
  onChange,
  selectedStatuses
}: StatusesFilterProps) {
  return (
    <MultiSelectFilter
      onChange={(values) => {
        let _values = [...values];
        if (values.includes('in_progress')) _values.push('pending');
        if (!values.includes('in_progress'))
          _values = _values.filter((i) => i !== 'pending');
        onChange(_values);
      }}
      selectedKeys={selectedStatuses}
      items={statusItems}
      placeholder="Status"
    />
  );
});
